/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Team_Manager_Toggle_Ad_Plugin_AriaInputs */

const en_team_manager_toggle_ad_plugin_aria = /** @type {(inputs: Team_Manager_Toggle_Ad_Plugin_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Toggle AD Plugin for ${i?.name}`)
};

const fr_team_manager_toggle_ad_plugin_aria = /** @type {(inputs: Team_Manager_Toggle_Ad_Plugin_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Basculer le plug-in AD pour ${i?.name}`)
};

const de_team_manager_toggle_ad_plugin_aria = /** @type {(inputs: Team_Manager_Toggle_Ad_Plugin_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AD-Plugin für ${i?.name} umschalten`)
};

const it_team_manager_toggle_ad_plugin_aria = /** @type {(inputs: Team_Manager_Toggle_Ad_Plugin_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Attiva/disattiva il plugin AD per ${i?.name}`)
};

const ru_team_manager_toggle_ad_plugin_aria = /** @type {(inputs: Team_Manager_Toggle_Ad_Plugin_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Включить/выключить рекламный плагин для ${i?.name}`)
};

const es_team_manager_toggle_ad_plugin_aria = /** @type {(inputs: Team_Manager_Toggle_Ad_Plugin_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Activar o desactivar el complemento AD para ${i?.name}`)
};

const zh_cn2_team_manager_toggle_ad_plugin_aria = /** @type {(inputs: Team_Manager_Toggle_Ad_Plugin_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`切换 ${i?.name} 的广告插件`)
};

const ja_team_manager_toggle_ad_plugin_aria = /** @type {(inputs: Team_Manager_Toggle_Ad_Plugin_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} の広告プラグインを切り替える`)
};

const hi_team_manager_toggle_ad_plugin_aria = /** @type {(inputs: Team_Manager_Toggle_Ad_Plugin_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} के लिए AD प्लगइन को टॉगल करें`)
};

const pt_pt2_team_manager_toggle_ad_plugin_aria = /** @type {(inputs: Team_Manager_Toggle_Ad_Plugin_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ativar/Desativar Plugin de Anúncios para ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Toggle AD Plugin for {name}" |
*
* @param {Team_Manager_Toggle_Ad_Plugin_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_toggle_ad_plugin_aria = /** @type {((inputs: Team_Manager_Toggle_Ad_Plugin_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Toggle_Ad_Plugin_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_toggle_ad_plugin_aria(inputs)
	if (locale === "de") return de_team_manager_toggle_ad_plugin_aria(inputs)
	if (locale === "it") return it_team_manager_toggle_ad_plugin_aria(inputs)
	if (locale === "ru") return ru_team_manager_toggle_ad_plugin_aria(inputs)
	if (locale === "es") return es_team_manager_toggle_ad_plugin_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_toggle_ad_plugin_aria(inputs)
	if (locale === "ja") return ja_team_manager_toggle_ad_plugin_aria(inputs)
	if (locale === "hi") return hi_team_manager_toggle_ad_plugin_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_toggle_ad_plugin_aria(inputs)
	return en_team_manager_toggle_ad_plugin_aria(inputs)
});